_collow.components.AdminControlGroupsCreate = class AdminControlGroupsCreate extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(elements.buttonReturn, "click", this.clickReturn)
    this.listen(elements.buttonPrevious, "click", this.clickPrevious)
    this.listen(elements.buttonNextName, "click", this.clickNext)
    this.listen(elements.buttonNext, "click", this.clickNext)
    this.listen(elements.buttonSave, "click", this.clickSave)
    this.listen(elements.buttonAdd, "click", this.clickAdd)
    this.listen(elements.buttonRemove, "click", this.clickRemove)
    this.listen(document, "_collow.overlay.clicked", () => this.showHidePopup(false));

    this.listen(elements.coursesUsersSearch, "input", (event) => this.handleSearch(event, "all", this.level));
    this.listen(elements.addedCoursesMembersSearch, "input", (event) => this.handleSearch(event, "added", this.level));

    this.groupCreate(1);
  }
  groupName = "";
  fetchedCourses = [];
  fetchedMembers = [];
  selectedCourses = [];
  selectedMembers = [];

  clickReturn = () => {
    this.showHidePopup(true)
    this.dispatch(this.root, "_collow.popup", { type: "open" });
  }
  clickReturnConfirm = () => {
    window.location.href = '/group';
  }
  clickPrevious = () => {
    const newLevel = this.level - 1;
    this.clearSearchBars();
    if (newLevel >= 1) {
      this.groupCreate(newLevel);
    }
  }

  clickNext = () => {
    if (this.level === 1 && this.elements.inputGroupName.value.length === 0) {
      _collow.Notify.error(this.params.errornoname)
    }
    else {
      const newLevel = this.level + 1;
      this.clearSearchBars();
      if (newLevel <= 3) {
        this.groupCreate(newLevel)
      }
    }
  }

  clearSearchBars = () => {
    this.elements.coursesUsersSearch.value = "";
    this.elements.addedCoursesMembersSearch.value = "";
  }

  clickSave = () => {
    //fetch all
    const groupName = this.elements.inputGroupName.value;
    const course_uis = this.selectedCourses.map(course => course.unique_identifer);
    const user_ids = this.selectedMembers.map(member => member.user_id);

    const formData = new FormData()
    formData.append("name", groupName);
    formData.append("users_id", user_ids)
    formData.append("courses_ui", course_uis);

    this.fetchPostGroup(formData);
  }

  clickAdd = () => {
    const liSelected = this.elements.coursesMembersUlSelect.querySelectorAll("li.active");

    liSelected.forEach(li => {
      if (li.hasAttribute("data-course_ui")) {
        const course = { course_name: li.textContent, unique_identifer: li.dataset.course_ui };
        this.selectedCourses.push(course);
        this.putItemInUl(this.elements.coursesMembersUlSelected, course);
      } else if (li.hasAttribute("data-user_id")) {
        const member = { firstname: li.textContent.trim(), user_id: li.dataset.user_id };
        this.selectedMembers.push(member);
        this.putItemInUl(this.elements.coursesMembersUlSelected, member, false);
      }
      li.remove();
    });
  }

  /**
     * Searches the courses list for the provided search term.
     * @param {*} event input event
     * @param {courses | addedCourses} listType the list to search on
     */
  handleSearch = (event, listType, level) => {
    switch (level) {
      case 2:
        if (listType === "all") {
          const filteredCourses = this.fetchedCourses.filter(c => c.course_name.toLowerCase().includes(event.target.value.toLowerCase()));

          this.elements.coursesMembersUlSelect.textContent = "";
          filteredCourses.forEach(course => this.putItemInUl(this.elements.coursesMembersUlSelect, course));
        } else if (listType === "added") {
          const filteredAddedCourses = this.selectedCourses.filter(c => c.course_name.toLowerCase().includes(event.target.value.toLowerCase()));

          this.elements.coursesMembersUlSelected.textContent = "";
          filteredAddedCourses.forEach(course => this.putItemInUl(this.elements.coursesMembersUlSelected, course));
        }
        break;
      case 3:
        if (listType === "all") {
          const filteredUsers = this.fetchedMembers.filter(user => this.getUserName(user).toLowerCase().includes(event.target.value.toLowerCase()));

          this.elements.coursesMembersUlSelect.textContent = "";
          filteredUsers.forEach(user => this.putItemInUl(this.elements.coursesMembersUlSelect, user, false));
        } else if (listType === "added") {
          const filteredMembers = this.selectedMembers.filter(user => this.getUserName(user).toLowerCase().includes(event.target.value.toLowerCase()));

          this.elements.coursesMembersUlSelected.textContent = "";
          filteredMembers.forEach(user => this.putItemInUl(this.elements.coursesMembersUlSelected, user, false));
        }
        break;
    }
  }

  clickRemove = () => {
    const liSelected = this.elements.coursesMembersUlSelected.querySelectorAll("li.active");

    liSelected.forEach(li => {
      if (li.hasAttribute("data-course_ui")) {
        const course = { course_name: li.textContent, unique_identifer: li.dataset.course_ui };

        const courseIdentifier = li.dataset.course_ui;
        this.selectedCourses = this.selectedCourses.filter(course => course.unique_identifer !== courseIdentifier);

        this.putItemInUl(this.elements.coursesMembersUlSelect, course);
      } else if (li.hasAttribute("data-user_id")) {
        const member = { firstname: li.textContent.trim(), user_id: li.dataset.user_id };

        const userId = li.dataset.user_id;
        this.selectedMembers = this.selectedMembers.filter(member => member.user_id !== userId);

        this.putItemInUl(this.elements.coursesMembersUlSelect, member, false);
      }
      li.remove();
    });
  }

  setHidden = (attribute, hidden = true) => {
    if (hidden) {
      if (!attribute.hasAttribute("hidden")) {
        attribute.setAttribute("hidden", "");
      }
    }
    else {
      if (attribute.hasAttribute("hidden")) {
        attribute.removeAttribute("hidden", "")
      }
    }
  }
  setVague = (attribute, vague = true) => {
    if (vague) {
      if (!attribute.classList.contains("vague-effect")) {
        attribute.classList.add("vague-effect");
      }
    }
    else {
      if (attribute.classList.contains("vague-effect")) {
        attribute.classList.remove("vague-effect")
      }
    }
  }

  /**
  * Returns the username of a user.
  * If the user has both a firstname and a lastname, the full name will be returned.
  * If the user has only a firstname or an email, that value will be returned.
  *
  * @param {Object} user - The user object.
  * @returns {string} The username of the user.
  */
  getUserName = (user) => {
    let name = user.firstname || user.email;
    if (user.firstname && user.lastname) {
      name += " " + user.lastname;
    }
    return name;
  }


  fetchCourses = async () => {
    const page = window.document.body
    page.classList.add("loading")

    const response = await fetch(this.params.path + "/course/", {
      method: "GET",
      headers: {
        Authorization: window.localStorage.getItem("token"),
      },
    });

    const res = await response.json()

    if (!response.ok) {
      if (res.detail.error_code === 'group_name-in-use') {
        _collow.Notify.error(this.params.errornameused)
      }
      else {
        _collow.Notify.error(this.params.errorgeneral)
      }
    } else {
      this.fetchedCourses = res
    }

    page.classList.remove("loading")
  }
  fetchMembers = async () => {
    const page = window.document.body
    page.classList.add("loading")

    const response = await fetch(this.params.path + "/admin/user", {
      method: "GET",
      headers: {
        Authorization: window.localStorage.getItem("token"),
      },
    });

    const res = await response.json()
    if (!response.ok) {
      if (res.detail.error_code === 'group_name-in-use') {
        _collow.Notify.error(this.params.errornameused)
      }
      else {
        _collow.Notify.error(this.params.errorgeneral)
      }
    } else {
      this.fetchedMembers = res
    }

    page.classList.remove("loading")
  }
  putItemInUl = (ul, item, course = true) => {
    const checkboxElement = document.createElement('input')
    checkboxElement.setAttribute("type", "checkbox")
    checkboxElement.style.marginRight = "8px"
    const li = document.createElement("li")
    li.classList.add("notranslate")
    li.style.justifyContent = "start"
    const text = document.createElement("span")

    if (course) {
      text.textContent = item.course_name;
      li.dataset.course_ui = item.unique_identifer;
    } else {
      text.textContent = this.getUserName(item);
      li.dataset.user_id = item.user_id;
    }
    li.append(checkboxElement)
    li.appendChild(text)
    li.addEventListener("click", () => {
      checkboxElement.toggleAttribute("checked"),
        li.classList.toggle("active")
    })
    ul.append(li);
  }

  level = 1;
  groupCreate = async (level) => {
    this.level = level

    //COMPONENTS
    const level1 = document.querySelector(".admin-groups-create-level1");
    const level2 = document.querySelector(".admin-groups-create-level2");
    const buttonPrevious = document.querySelector(".btn-previous");
    const buttonNextName = document.querySelector(".btn-next-name")
    const buttonNext = document.querySelector(".btn-next");
    const buttonSave = document.querySelector(".btn-save");

    //PROGRESS COMPONENTS
    const progress_level1 = document.querySelector(".admin-groups-create-progress-level1");
    const progress_line1 = document.querySelector(".admin-groups-create-progress-container-line-1");
    const progress_level2 = document.querySelector(".admin-groups-create-progress-level2");
    const progress_line2 = document.querySelector(".admin-groups-create-progress-container-line-2");
    const progress_level3 = document.querySelector(".admin-groups-create-progress-level3");

    switch (level) {
      case 1: //group name
        // in initial state all attributes are hidden and all progress items are vague
        this.setHidden(level1, false)
        this.setHidden(level2)
        this.setHidden(buttonPrevious)
        this.setHidden(buttonNext, false)
        this.setHidden(buttonSave)

        this.setVague(progress_level1, false)
        this.setVague(progress_line1, false)
        this.setVague(progress_level2)
        this.setVague(progress_line2)
        this.setVague(progress_level3)
        break;

      case 2: //courses
        //changes title in title-courses-select and title-courses-selected according to the current step
        this.elements.titleCoursesSelectTraining.removeAttribute("hidden")
        this.elements.titleCoursesSelectUsers.setAttribute("hidden", "")
        this.elements.titleCoursesSelectedTraining.removeAttribute("hidden")
        this.elements.titleCoursesSelectedUsers.setAttribute("hidden", "")
        //load all courses in courses-members-ul-select
        this.setHidden(level1)
        this.setHidden(level2, false)
        this.setHidden(buttonPrevious, false)
        this.setHidden(buttonNext, false)
        this.setHidden(buttonSave)

        this.setVague(progress_level1)
        this.setVague(progress_line1)
        this.setVague(progress_level2, false)
        this.setVague(progress_line2, false)
        this.setVague(progress_level3)

        if (this.fetchedCourses.length === 0 && this.selectedCourses.length === 0) {
          await this.fetchCourses();
        }
        this.elements.coursesMembersUlSelect.textContent = "";
        this.fetchedCourses.forEach(course => this.putItemInUl(this.elements.coursesMembersUlSelect, course));

        this.elements.coursesMembersUlSelected.textContent = "";
        this.selectedCourses.forEach(course => this.putItemInUl(this.elements.coursesMembersUlSelected, course));

        break;

      case 3: //members
        //changes title in title-courses-select and title-courses-selected according to the current step
        this.elements.titleCoursesSelectTraining.setAttribute("hidden", "")
        this.elements.titleCoursesSelectUsers.removeAttribute("hidden")
        this.elements.titleCoursesSelectedTraining.setAttribute("hidden", "")
        this.elements.titleCoursesSelectedUsers.removeAttribute("hidden")
        //load all members in courses-members-ul-select
        this.setHidden(level1)
        this.setHidden(level2, false)
        this.setHidden(buttonPrevious, false)
        this.setHidden(buttonNext)
        this.setHidden(buttonSave, false)

        this.setVague(progress_level1)
        this.setVague(progress_line1)
        this.setVague(progress_level2)
        this.setVague(progress_line2)
        this.setVague(progress_level3, false)

        this.elements.coursesMembersUlSelect.textContent = "";

        if (this.fetchedMembers.length === 0 && this.selectedMembers.length === 0) {
          await this.fetchMembers();
        }

        this.fetchedMembers.forEach(user => this.putItemInUl(this.elements.coursesMembersUlSelect, user, false));

        this.elements.coursesMembersUlSelected.textContent = "";
        this.selectedMembers.forEach(member => this.putItemInUl(this.elements.coursesMembersUlSelected, member, false));

        break;

      default:
        //do nothing
        break;
    }
  }
  fetchPostGroup = async (form_data) => {
    const page = window.document.body
    page.classList.add("loading")

    const response = await fetch(this.params.path + "/admin/group", {
      method: "POST",
      body: form_data,
      headers: {
        Authorization: window.localStorage.getItem("token"),
      },
    });

    const res = await response.json()
    if (!response.ok) {
      if (res.detail.error_code === 'group_name-in-use') {
        _collow.Notify.error(this.params.errornameused)
      }
      else {
        _collow.Notify.error(this.params.errorgeneral)
      }
    } else if (response.ok) {
      page.classList.remove("loading")
      window.location.href = '/group';
    }
  }

  deselectAll = () => {
    this.dispatch(this.root, "_collow.popup", { type: "close" });
  };

  showHidePopup = (state = false) => {
    if (state) {
      this.elements.returnPopup.removeAttribute("hidden")
      this.listen(this.elements.returnPopupConfirm, "click", this.clickReturnConfirm);
      this.listen(this.elements.returnPopupCancel, "click", () => this.showHidePopup(false));
    } else {
      this.elements.returnPopup.setAttribute("hidden", "")
      this.unlisten(this.elements.returnPopupConfirm, "click", this.clickReturnConfirm);
      this.unlisten(this.elements.returnPopupCancel, "click", this.showHidePopup);
      this.deselectAll()
    }
  };
};
